import './mobile-card.scss';

import { Pagination } from 'antd';
import React from 'react';

import { LEASING_STATUSES } from '@/constants';
import { useWindowSize } from '@/hooks/useWindowSize';

import type { TLeasingOrder } from '../../../types';

type TProps = {
  data: TLeasingOrder[];
  pagination: {
    current: number;
    pageSize: number;
    total: number;
  };
  onPageChange: (page: number, pageSize: number) => void;
  onClick: (row: TLeasingOrder) => void;
};

const MobileCard: React.FC<TProps> = ({
  data,
  pagination,
  onPageChange,
  onClick
}) => {
  const [windowWidth] = useWindowSize();

  return (
    <div className="individual-leasing-card">
      {!data || data.length === 0 ? (
        <p className="individual-leasing-card__no-data">Нет заявок</p>
      ) : (
        data.map((item) => {
          const currentColors = LEASING_STATUSES[
            item.status?.code as keyof typeof LEASING_STATUSES
          ] || {
            textColor: '#A0AEC0',
            bgColor: '#F1F2F4'
          };
          return (
            <div
              key={item.uuid}
              onClick={() => onClick(item)}
              className="individual-leasing-card__card"
            >
              <div className="individual-leasing-card__card-header">
                <div>
                  <p className="individual-leasing-card__name">
                    {item.companyName ||
                      item.client?.titleCompany ||
                      'Нет данных'}
                  </p>
                  <p className="individual-leasing-card__inn">
                    {item.iin || item.client?.clientIin || 'Нет данных'}
                  </p>
                </div>
              </div>
              <div
                className="individual-leasing-card__status"
                style={{
                  color: currentColors.color,
                  backgroundColor: currentColors.bgColor
                }}
              >
                {item.status?.name}
              </div>
            </div>
          );
        })
      )}
      <Pagination
        className="individual-leasing-card__pagination"
        current={pagination.current}
        pageSize={pagination.pageSize}
        total={pagination.total}
        showSizeChanger={false}
        simple={windowWidth <= 560}
        showLessItems={windowWidth <= 560}
        onChange={(page, pageSize) => {
          onPageChange(page, pageSize);
        }}
      />
    </div>
  );
};

export default MobileCard;
